import React from "react";
import useMyPermissions from "./useMyPermissions";

/**
 * Section/action-level permission gate.
 *
 * <Can module="paymentTerminalService" action="add">
 *   <button>+ Add Terminal</button>
 * </Can>
 *
 * Renders nothing while the permission check is loading (avoids a flash of
 * a button the user isn't allowed to use), then either the children or
 * `fallback` (default: nothing) depending on the result.
 */
const Can = ({ module, action, fallback = null, children }) => {
  const { loading, can } = useMyPermissions();
  if (loading) return null;
  return can(module, action) ? children : fallback;
};

export default Can;
